import { createTermTagManager } from '../../utils/createTermTagManager';

export const hasVideoTagManager = createTermTagManager({
  jsonQueryKey: 'has_video',
  label: 'Только с видео',
  id: 'hasVideo',
});
